<article class="message is-warning mx-6 my-6">
    <div class="message-body is-size-7">
        준비중입니다.
    </div>    
</article>
